import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const propTypes = {
	row: PropTypes.object.isRequired,
	answer: PropTypes.object.isRequired,
	number: PropTypes.number.isRequired
};

const RowQuestion = (props) => {
	let {row, answer, number} = props
	return (
		<tr>
			<td>
				{number ?
					<div className="field">
						<strong>{(number) + '. ' + row.name}</strong>
					</div> : <p>{row.name}</p>}

				<div className="field">
					{row.type === 'sum' && answer ?
						!_.isEmpty(answer.answer_text) ? <p>{`${answer.answer_number} - ${answer.answer_text}`}</p>
							: <p>{answer.answer_text}</p> : ''}
				</div>
			</td>
		</tr>
	)
}

RowQuestion.propTypes = propTypes;

export default RowQuestion;


// WEBPACK FOOTER //
// ./src/elements/revision/widget/row_widget.jsx